import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NavComponent } from './nav.component';
import { RouterModule } from '@angular/router';
import { MDBBootstrapModule } from 'angular-bootstrap-md';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatCheckboxModule } from '@angular/material/checkbox';

@NgModule({
    imports: [CommonModule, RouterModule, MatSlideToggleModule, MatCheckboxModule, MDBBootstrapModule],
    declarations: [NavComponent],
    exports: [NavComponent, FormsModule]
})
export class NavModule { }
